"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configurations = {
    dev: {
        vindi_sanar: {
            url: 'https://sandbox-app.vindi.com.br/api',
            publicApiToken: 'vv8O-NysDOYazRV8TiwYu_m9Q3BDtKBI4vFQZd2mMIs:',
        },
        vindi_cetrus: {
            url: 'https://sandbox-app.vindi.com.br/api',
            publicApiToken: 'FAzjTtxWr_rlrJwqxkg2WRWQ_gNDisdx83Xx5q0tcPU:',
        },
        vindi_sanar_saude: {
            url: 'https://sandbox-app.vindi.com.br/api',
            publicApiToken: 'bNyjUOYfwMVGvdbbDRnk-KdZBT1S9FsjCswZE1URQSw:',
        },
    },
    qa: {
        vindi_sanar: {
            url: 'https://sandbox-app.vindi.com.br/api',
            publicApiToken: 'vv8O-NysDOYazRV8TiwYu_m9Q3BDtKBI4vFQZd2mMIs:',
        },
        vindi_cetrus: {
            url: 'https://sandbox-app.vindi.com.br/api',
            publicApiToken: 'FAzjTtxWr_rlrJwqxkg2WRWQ_gNDisdx83Xx5q0tcPU:',
        },
        vindi_sanar_saude: {
            url: 'https://sandbox-app.vindi.com.br/api',
            publicApiToken: 'bNyjUOYfwMVGvdbbDRnk-KdZBT1S9FsjCswZE1URQSw:',
        },
    },
    preprod: {
        vindi_sanar: {
            url: 'https://sandbox-app.vindi.com.br/api',
            publicApiToken: 'vv8O-NysDOYazRV8TiwYu_m9Q3BDtKBI4vFQZd2mMIs:',
        },
        vindi_cetrus: {
            url: 'https://sandbox-app.vindi.com.br/api',
            publicApiToken: 'FAzjTtxWr_rlrJwqxkg2WRWQ_gNDisdx83Xx5q0tcPU:',
        },
        vindi_sanar_saude: {
            url: 'https://sandbox-app.vindi.com.br/api',
            publicApiToken: 'bNyjUOYfwMVGvdbbDRnk-KdZBT1S9FsjCswZE1URQSw:',
        },
    },
    prod: {
        vindi_sanar: {
            url: 'https://app.vindi.com.br/api',
            publicApiToken: 'OHV1HZGmfQw5CVvVIIIibXXeI_dqsk3LHa2lq3xlRcs:',
        },
        vindi_cetrus: {
            url: 'https://app.vindi.com.br/api',
            publicApiToken: 'i3N0wQX5wfRUIKgDxaCgi_Sr5KnAL8sdYwQICuzOg9k:',
        },
        vindi_sanar_saude: {
            url: 'https://app.vindi.com.br/api',
            publicApiToken: 'q-vIxNXIM071cT-30UkA_l15r3zKQF01nvRkikjJ7vc:',
        },
    },
};
exports.default = configurations;
